import { createAsyncThunk } from '@reduxjs/toolkit';

import loggerGenerator from '@travel/logger';

import { apiPath } from 'constants/api';
import { INTERNAL_SERVER_ERROR } from 'constants/common';

import type { ApiClient } from '@travel/api-client';
import { noticeError } from '@travel/tracker';

const logger = loggerGenerator();

export const deleteReviewById = createAsyncThunk<
  string,
  string,
  { extra: { apiClient: ApiClient } }
>('review/delete', async (reviewId, { extra: { apiClient }, rejectWithValue }) => {
  try {
    const path = apiPath.reviewDelete.pathname(reviewId);

    await apiClient.delete(path, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return reviewId;
  } catch (error) {
    logger.error('Delete Review Failed', error);
    noticeError('Delete Review Failed', error);

    return rejectWithValue({
      code: error?.response?.status || INTERNAL_SERVER_ERROR,
      message: error?.response?.data?.message || 'Failed to delete review',
    });
  }
});
